module.exports = __webpack_public_path__ + "media/images/refocus-c6af6128e59d0fc40a1333571a78a5e2.png";